import * as React from 'react'
import { observer, inject } from 'mobx-react'
import { StateType } from '../state/state'
import { Label } from '../../../components/ui/Label'
import { Toggle } from '@accurat/react-components'

interface Props {
  className?: string
  state?: StateType
}

export const ShowXYLabelsToggle: React.FC<Props> = inject('state')(
  observer(({ className = '', state }) => {
    const { showXYLabels, toggleShowXYLabels, activeCountries } = state.ScatterplotState
    const isChecked = showXYLabels

    return (
      <div
        className={`-show-xy-labels-toggle flex items-center ${className}`}
        style={{
          pointerEvents: activeCountries.length === 0 ? 'none' : null,
          opacity: activeCountries.length === 0 ? 0.5 : null,
        }}
      >
        <Label className="mr3 pr1" label="Show value of countries" />
        <Toggle
          className={`pointer br-pill transition`}
          style={{
            boxShadow: isChecked
              ? '0px 0px 0px 2px var(--blue500)'
              : '0px 0px 0px 2px var(--gray100)',
          }}
          inputClassName={`bn br-pill transition ${
            isChecked ? 'bg-blue500 white' : 'bg-gray100 gray500'
          }`}
          checked={isChecked}
          onChange={toggleShowXYLabels}
          disabled={activeCountries.length === 0} // DOES NOT WORK
        />
      </div>
    )
  })
)
